import React from "react";
import Input from "./Input";

export default class Currency extends React.Component<any, any> {
  handleBlur = (event: any) => {
    const { field, onBlur } = this.props;
    event.target.value = parseFloat(event.target.value);

    if (isNaN(event.target.value)) {
      event.target.value = "";
    } else {
      const [integer, decimal = ""] = event.target.value.split(".");
      event.target.value = [
        integer ? integer : "0",
        decimal.slice(0, 2).padEnd(2, "0"),
      ].join(".");
    }

    field.onChange(event);
    field.onBlur(event);

    if (onBlur) onBlur(event);
  };

  handleChange = (event: any) => {
    const { field, onChange } = this.props;
    event.target.value = event.target.value.trim();

    field.onChange(event);
    if (onChange) onChange(event);
  };

  render() {
    const {
      currency = "$",
      len = 85,
      className,
      signClassName,
      ...props
    } = this.props;
    return (
      <>
        <i
          className={`fa fa-dollar ${signClassName}`}
          style={{ position: "sticky" }}
        />
        <Input
          {...props}
          className={`${className} text-right`}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          style={{ width: `${len}%`, marginLeft: `${-12}px` }}
        />
      </>
    );
  }
}
